import { useMutation, useQueryClient } from '@tanstack/react-query';

import { cancelOnboarding } from '../../common/api/clients/supplierOnboarding.api';
import { queries } from '../../common/api/queryKeys/queries';

export const useCancelSupplierOnboarding = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (offerId: string) => cancelOnboarding(offerId),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: queries.supplierOnboarding._def,
            });
        },
    });
};
